import type { RangePickerProps } from 'antd/es/date-picker';
import type { RuleObject } from 'antd/es/form';
import type { TFunction } from 'i18next';

const validateLessThanMonthDateRange =
    (t: TFunction) => (_: RuleObject, value: RangePickerProps['value']) => {
        if (value && value.length === 2 && value[0] && value[1]) {
            const [start, end] = value;

            const diffInMonths = end.diff(start, 'months', true);

            if (diffInMonths > 1) {
                return Promise.reject(
                    new Error(
                        t('common.form_error.date_range_more_than_month'),
                    ),
                );
            }
        }

        return Promise.resolve();
    };

export { validateLessThanMonthDateRange };
